import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import apiClient from "../common/http.service";

export const useContentManagement = () => {
    const queryClient = useQueryClient();

    // GET Request
    const settingsQuery = useQuery({
        queryKey: ["contentManagement"],
        queryFn: async () => {
            const response = await apiClient.get("/contentmanagement");
            const data = response.data; 
            if (Array.isArray(data) && data.length > 0) {
                return data[0]; 
            }
            return null; 
        },
        staleTime: 5000,
    });

    // POST Request (Create new if database is empty)
    const createMutation = useMutation({
        mutationFn: async (payload) => {
            return apiClient.post(`/contentmanagement`, payload);
        },
        onSuccess: () => {
            toast.success("Settings created successfully");
            queryClient.invalidateQueries({ queryKey: ["contentManagement"] });
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || "Failed to create settings");
        },
    });

    // PUT Request (Update existing)
    const updateMutation = useMutation({
        mutationFn: async (payload) => {
            const { id, ...updateData } = payload; 
            return apiClient.put(`/contentmanagement/${id}`, updateData);
        },
        onSuccess: () => {
            toast.success("Settings updated successfully");
            queryClient.invalidateQueries({ queryKey: ["contentManagement"] });
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || "Failed to update settings");
        },
    });

    return {
        settings: settingsQuery.data,
        isLoading: settingsQuery.isLoading,
        
        createSettings: createMutation.mutateAsync,
        isCreating: createMutation.isPending,

        updateSettings: updateMutation.mutateAsync,
        isUpdating: updateMutation.isPending,
    };
};